import {MuWidget} from "mu-widget/lib/MuWidget";

export class BaseAppWidget extends MuWidget {
    protected hcHeader(): string {
        return `<div class="l-app-header">
				<span class="l-app-header__title" mu="title">Fitnotes</span>
				<span class="l-app-header__buttons" mu="buttonsHeader">
					<!-- <span mu="bDarkLight" class="theme-switcher"></span> -->
					<span class="icon--theme icon-size--1-5rem hover-click-pulse-20" mu="visualSetup"></span>
				</span>
			</div>`;
    }
}